/** Small display helpers. Pure functions — easy to read and easy to test. */

/** "2026-07-14" -> "14 Jul 2026". Falls back to the raw value if unparseable. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** 38000000 -> "$38M". Used when the API has no pre-formatted amount. */
export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `$${Math.round(value / 1_000_000)}M`;
  if (value >= 1_000) return `$${Math.round(value / 1_000)}K`;
  return `$${value}`;
}

/** 895805 -> "895,805" */
export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return value.toLocaleString("en-US");
}

/** Shows any empty-ish value as an em dash so table cells never look broken. */
export function orDash(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  return String(value);
}

/** Trims long free text so one row cannot blow up the table height. */
export function truncate(value: string | null | undefined, max = 90): string {
  if (!value) return "—";
  return value.length > max ? `${value.slice(0, max)}…` : value;
}

/** "https://www.velocity.xyz/careers" -> "velocity.xyz" */
export function hostname(url: string | null | undefined): string {
  if (!url) return "—";
  try {
    return new URL(url.startsWith("http") ? url : `https://${url}`).hostname.replace(
      /^www\./,
      "",
    );
  } catch {
    return url;
  }
}
